import { I_DepthInfo, I_FilterItem } from '@Redux/search/interfaces';
import dayjs from 'dayjs';

interface I_ResultConditionsParams {
    FilterItems: I_FilterItem[];
    DepthInfo?: I_DepthInfo;
    SortType: number;
    TagFiltersShow: string[];
    ChangeItem: boolean;
    Tags: string;
}

export interface I_ResultConditionsReturn {
    ArriveID: string | null;
    GoDatestart: string;
    GoDateEnd: string;
    GroupID: string | null;
    Keywords: string | null;
    IsEnsureGroup: string | boolean | null;
    IsSold: string | boolean | null;
    ThemeID: string | null;
    DepartureID: string | null;
    WeekDay: string;
    PriceList?: any;
    AirlineIDs: string;
    TripTypes: string;
    Tags: string;
    SortType: number | null;
    Days: string;
    TravelType: any;
    BuIDs: string;
}

const toBoolean = (parm: string | null) => {
    if (parm == 'true') {
        return true;
    } else if (parm == 'false') {
        return false;
    } else {
        return null;
    }
};

const urlParams = new URLSearchParams(window.location.search);

// 取得 url 上的參數
const urlObject = {
    ArriveID: urlParams.get('ArriveID'),
    GoDatestart: urlParams.get('GoDateStart') || dayjs().format('YYYY-MM-DD'),
    // GoDateEnd: urlParams.get('GoDateEnd') || dayjs().add(30, 'days').format('YYYY-MM-DD'),
    GroupID: urlParams.get('GroupID'),
    Keywords: urlParams.get('Keywords'),
    IsEnsureGroup: toBoolean(urlParams.get('IsEnsureGroup')),
    IsSold: toBoolean(urlParams.get('IsSold')),
    ThemeID: urlParams.get('ThemeID'),
    TravelPavilionGroupID: urlParams.get('TravelPavilionGroupID') || null,
    KeywordsCity: urlParams.get('KeywordsCity') || null,
    TravelType: urlParams.get('TravelType') || null,
    BuIDs: urlParams.get('bu'),
    PreferAirlines: urlParams.get('PreferAirlines') || null,
};

// 取得 GroupList 所需要參數
const getResultConditions = (searchParams: I_ResultConditionsParams): I_ResultConditionsReturn => {
    const { DepthInfo, FilterItems, SortType, TagFiltersShow, Tags, ChangeItem } = searchParams;
    const GoDateEnd = (() => {
        // 如果是旅遊館群，最晚出發日為多 1 年
        if (urlParams.get('TravelPavilionGroupID')) {
            return dayjs().add(3, 'year').format('YYYY-MM-DD');
        } else {
            return urlParams.get('GoDateEnd') || dayjs().add(30, 'days').format('YYYY-MM-DD');
        }
    })();

    const ConcatFilters = (type: string) =>
        FilterItems.reduce((accu: string, item: I_FilterItem) => {
            if (item.filterBy === type) {
                let accuArray = accu ? accu.split(',') : [];
                accuArray = [...accuArray, item.value.toString()];
                accu = accuArray.join();
            }
            return accu;
        }, '');

    const hasPriceCondition = !!FilterItems.some(
        (item: I_FilterItem) => item.filterBy === 'PriceRange'
    );

    const PriceCondition = (minOrMax: 'min' | 'max') =>
        FilterItems.find(
            (item: I_FilterItem) => item.filterBy === 'PriceRange' && item.subValue === minOrMax
        )?.value;

    const DepartureID = urlParams.get('DepartureID')
        ? urlParams.get('DepartureID')
        : ConcatFilters('DepartureList');

    const TravelType = (() => {
        const TravelTypeArray = FilterItems.reduce(
            (accu: number[], item: I_FilterItem): number[] => {
                return item.filterBy === 'TravelType' ? [...accu, Number(item.value)] : accu;
            },
            []
        );
        if (urlObject.TravelType !== null && !ChangeItem) {
            const tType = parseInt(urlObject.TravelType);
            return tType;
        }

        if (TravelTypeArray.length === 1) {
            return TravelTypeArray[0];
        }
        return 0;
    })();
    const WeekDay = ConcatFilters('WeekDays');
    const PriceList = [
        {
            PriceStart: PriceCondition('min') || DepthInfo?.PriceRange?.PriceStart || 0,
            PriceEnd: PriceCondition('max') || DepthInfo?.PriceRange?.PriceEnd || 0 || null,
        },
    ];

    // if (!PriceCondition('max')) {
    //     PriceList.push({
    //         PriceStart: PriceCondition('max') || DepthInfo?.PriceRange?.PriceEnd || 0,
    //         PriceEnd: null,
    //     });
    // }

    const TripTypes = TagFiltersShow.join();
    let categoryListTags = ConcatFilters('CategoryList');
    //直接改寫Tags
    if (Tags.indexOf(',') !== -1) {
        Tags.split(',').forEach((tag: string) => {
            if (categoryListTags.indexOf(tag) === -1) {
                categoryListTags += ',' + tag;
            }
        });
    } else {
        if (categoryListTags.indexOf(Tags) === -1) {
            if (categoryListTags !== '') {
                categoryListTags += ',' + Tags;
            } else {
                categoryListTags += Tags;
            }
        }
    }
    const Days = ConcatFilters('DayList');

    const BuIDs = urlObject.BuIDs && !ChangeItem ? urlObject.BuIDs : ConcatFilters('BuList');
    const AirlineIDs =
        urlObject.PreferAirlines && !ChangeItem
            ? urlObject.PreferAirlines
            : ConcatFilters('AirlineList');

    return {
        ...urlObject,
        GoDateEnd,
        DepartureID,
        WeekDay,
        PriceList: hasPriceCondition ? PriceList : null,
        AirlineIDs,
        TripTypes,
        Tags: categoryListTags,
        SortType: SortType === -1 ? null : SortType, // -1 為依關聯度搜尋需送 null,
        Days,
        TravelType,
        BuIDs,
    };
};

export default getResultConditions;
